import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import { formatOptionalId } from './withdrawConstants';

/**
 * 提現拒絕審核（與 KYC 拒絕相同：必填失敗原因）。
 */
export default function WithdrawRejectModal({ open, row, onClose, onSuccess }) {
  const [failedInfo, setFailedInfo] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setFailedInfo('');
      setError('');
      setSubmitting(false);
    }
  }, [open, row?.id]);

  if (!open || !row) {
    return null;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const remark = failedInfo.trim();
    if (!remark) {
      setError('請輸入審核失敗原因');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await adminApi.withdrawAudit({
        id: row.id,
        action: 'CONFIRM',
        confirmStatus: 'REJECT',
        failedInfo: remark,
      });
      onSuccess?.();
      onClose?.();
    } catch (err) {
      setError(err.message || '拒絕失敗');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal"
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>拒絕提現</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <p className="page-desc">
              提現單號：
              <span className="mono-cell">{formatOptionalId(row.id)}</span>
            </p>
            <div className="form-field">
              <label htmlFor="withdrawRejectReason">
                審核失敗原因
                <span className="form-required">*</span>
              </label>
              <textarea
                id="withdrawRejectReason"
                rows={4}
                value={failedInfo}
                onChange={(event) => setFailedInfo(event.target.value)}
                placeholder="請輸入拒絕原因"
                disabled={submitting}
                autoFocus
              />
            </div>
            {error ? <div className="alert alert-error">{error}</div> : null}
          </div>
          <div className="admin-modal__footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={submitting}>
              關閉
            </button>
            <button type="submit" className="btn btn-danger" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
